<template>
  <SocialImage
    title="Twitter"
    :channel="channel"
  />
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'TwitterImage',
  components: {
    SocialImage,
  },
  computed: {
    channel() {
      return this.$vuetify.theme.dark ? 'twitterdark' : 'twitter';
    },
  },
};
</script>

